export const APPICONFIG = {
  version: '1.0.0',
  Client: 'SGS',
  Backend_API_VERSION: 'v1',
  TOKEN_NAME: 'token_lms',
  API_URL:
    'https://lvs.qualicius.cloud/api/' /*https://lvs.qualicius.cloud/api/ https://lvs-net7-api.azurewebsites.net/api/ https://localhost:5001/api/ https://lms-peral-api.azurewebsites.net/api/ */,
  API_PATHS: {
    UPLOAD: {
      VERSION: 'v1/',
      UPLOAD: 'upload/upload',
      DOWNLOAD: 'upload/{id}/download',
    },
    TOKENS: {
      CREATE: 'tokens',
      REFRESH: 'tokens/refresh',
      VALIDATE: 'tokens/validate',
    },
    USERS: {
      LIST: 'users',
      CREATE: 'users',
      DETAILS: 'users/{id}',
      ROLES_LIST: 'users/',
      ROLES_UPDATE: 'users/',
      SELF_REGISTER: 'users/self-register',
      TOGLE_STATUS: 'users/{id}/toggle-status',
      CONFIRM_EMAIL: 'users/confirm-email',
      CONFIRM_PHONE_NUMBER: 'user/confirm-phone-number',
      FORGOT_PASSWORD: 'users/forgot-password',
      RESET_PASSWORD: 'users/reset-password',
      EDIT: 'users/update-user/?id=',
    },
    PERSONAL: {
      GETPROFILE: 'personal/profile',
      EDITPROFILE: 'personal/profile',
      CHANGEPASSWORD: 'personal/change-password',
      GETPERMISSIONS: 'personal/permissions',
      GETLOGS: 'personal/logs',
      GETROLES: 'personal/roles',
    },
    COUNTRIES: {
      VERSION: 'v1/',
      LIST: 'countries/search',
      GETBYCURRENTUSER: 'countries/get-current-user-countries',
      GETBYID: 'countries/{id}',
      UPDATE: 'countries/{id}',
      DELETE: 'countries/{id}',
      CREATE: 'countries',
    },
    WORKINGDAYS: {
      VERSION: 'v1/',
      LIST: 'workingdays/search',
      GETBYID: 'workingdays/{id}',
      UPDATE: 'workingdays/{id}',
      DELETE: 'workingdays/{id}',
      CREATE: 'workingdays',
    },
    AFFILIATES: {
      LIST: 'v1/affiliates/search',
      DETAILS: 'v1/affiliates',
      CREATE: 'v1/affiliates',
      EDIT: 'v1/affiliates',
      DELETE: 'v1/affiliates',
      GETCOORDINATORS: 'v1/affiliates/get-coordinators',
    },
    ARTICLES: {
      LIST: 'v1/articles/search',
      DETAILS: 'v1/articles',
      CREATE: 'v1/articles',
      EDIT: 'v1/articles',
      DELETE: 'v1/articles',
    },
    ROLES: {
      LIST: 'roles',
    },
    COMPANIES: {
      LIST: 'v1/companycustomers/search',
      DETAILS: 'v1/companycustomers',
      CREATE: 'v1/companycustomers',
      EDIT: 'v1/companycustomers',
      DELETE: 'v1/companycustomers',
    },
    PUBLICHOLIDAYS: {
      LIST: 'v1/publicholidays/search',
      CREATE: 'v1/publicholidays',
      DELETE: 'v1/publicholidays/{id}',
    },
    QUESTIONS: {
      VERSION: 'v1/',
      LIST: 'questions/search',
      GETBYID: 'questions/{id}',
      UPDATE: 'questions/{id}',
      DELETE: 'questions/{id}',
      CREATE: 'questions',
    },
    HELPTEXTSCLIENT: {
      VERSION: 'v1/',
      LIST: 'helptextsclient/search',
      GETBYID: 'helptextsclient/{id}',
      UPDATE: 'helptextsclient/{id}',
      DELETE: 'helptextsclient/{id}',
      CREATE: 'helptextsclient',
    },
    HELPTEXTSREVIEWER: {
      VERSION: 'v1/',
      LIST: 'helptextsreviewer/search',
      GETBYID: 'helptextsreviewer/{id}',
      UPDATE: 'helptextsreviewer/{id}',
      DELETE: 'helptextsreviewer/{id}',
      CREATE: 'helptextsreviewer',
    },
    REVIEWTYPES: {
      VERSION: 'v1/',
      LIST: 'reviewtypes/search',
      GETBYCURRENTUSER: 'reviewtypes/get-current-user-review-types',
      GETBYID: 'reviewtypes/{id}',
      UPDATE: 'reviewtypes/{id}',
      DELETE: 'reviewtypes/{id}',
      CREATE: 'reviewtypes',
    },
    ASSIGMENTS: {
      VERSION: 'v1/',
      LIST: 'assignments/search',
      GETBYID: 'assignments/{id}',
      UPDATE: 'assignments/{id}',
      DELETE: 'assignments/{id}',
      CREATE: 'assignments',
      GETBYCURRENTUSER: 'assignments/get-assignments-current-user',
      SEARCH: 'assignments/searchassignments',
      GETPREVBYLABELART: 'assignments/get-previous-assignments-by-label-article-number',
      TURNINPROGRESS: 'assignments/turn-assignment-into-progress',
      TURNTOASSIGNED: 'assignments/turn-assignment-to-assigned?id={id}',
      TURNTONEW: 'assignments/turn-assignment-back-to-new',
      TURNTOFINISH: 'assignments/turn-assignment-into-finish',
      TURNTORELEASETOCLIENT: 'assignments/turn-assignment-realease-to-client',
      ANSWERS: {
        GETBYID: 'assignmentresponses?id={id}',
        GETBYASSIGNMENT: 'assignmentresponses/get-responses-assignment',
        UPDATEMULTIPLE: 'assignmentresponses/update-multiple',
      },
      COUNTRIES: {
        CREATEMULTIPLE: 'assignmentcountries/create-multiple',
        GETAVAILABLEFORASSIGNMENT: 'assignmentcountries/get-available-assignment-countries?id={id}',
        GETASSIGNMENTCOUNTRIES:
          'assignmentcountries/get-assignment-countries-by-assignment-minimal?id={id}',
        DELETE: 'assignmentcountries/{id}',
        TURNINPROGRESS: 'assignmentcountries/turn-into-proccess',
        TURNTOFINISH: 'assignmentcountries/turn-into-finish',
        UPDATEBYREVIEWER: 'assignmentcountries/{id}/reviewer',
      },
      ARTWORKS: {
        CREATE: 'assignmentartworks',
        DELETE: 'assignmentartworks/{id}',
        GETBYID: 'assignmentartworks/{id}',
        GETALLBYASSIGNMENT: 'assignmentartworks/get-all-artworks-assignment',
      },
      QUESTIONS: {
        GETBYASSIGNMENTID: 'assignmentquestions/get-by-assignment',
        UPDATEMULTIPLE: 'assignmentquestions/update-multiple',
      },
      DOCUMENTS: {
        CREATE: 'assignmentdocuments',
        GETBYASSIGNMENT: 'assignmentdocuments/get-all-documents-assignment',
        CREATESGS: 'assignmentdocuments/create-sgs',
        GETBYASSIGNMENTSGS: 'assignmentdocuments/get-all-documents-sgs-assignment',
        DELETE: 'assignmentdocuments/{id}',
      },
      PHOTOS: {
        CREATE: 'assignmentphotos',
        GETBYASSIGNMENT: 'assignmentphotos/get-all-photos-assignment',
        DELETE: 'assignmentphotos/{id}',
      },
    },
    REVIEWCOMMENTS: {
      MAILBOX: 'v1/reviewcomments/get-mailbox',
      RECIPIENTS: 'v1/reviewcomments/available-recipients',
      DETAILS: 'v1/reviewcomments/{id}',
      CREATE: 'v1/reviewcomments',
      DELETE: 'v1/reviewcomments/{id}',
    },
    REPORTS: {
      VERSION: 'v1/',
      CLIENTGETTEMPLATE: 'reports/template/{id}/client',
      CLIENTIMPORTTEMPLATE: 'reports/import/{id}/client',
      REVIEWERGETTEMPLATE: 'reports/template/{id}/reviewer',
      REVIEWERIMPORTTEMPLATE: 'reports/import/{id}/reviewer',
      DOWNLOADTEMPLATE: 'reports/template/{id}'
    },
    LOOKUPS: {
      VERSION: 'v1/',
      GETCOMPANYCUSTOMERS: 'lookups/get-company-customers',
      GETCOMPANYCUSTOMERSANDAFFILIATES: 'lookups/get-company-customers-and-affiliates',
      GETREGIONS: 'lookups/get-regions',
      GETCOUNTRIES: 'lookups/get-countries'
    },
    DASHBOARD: {
      VERSION: 'v1/',
      GETCHARTDATA: 'dashboard/get-assignments-current-user'
    },
    ASK: {
      VERSION: 'v1/',
      ASKASSIGNMENTRESPONSEHELP: 'ask/{id}'
    }
  },
  API_RESPONSE_HEADER: {
    OK: 200,
    BAD_REQUEST: 400,
    NOT_AUTHORIZED: 401,
    NOT_FOUND: 404,
    FORBIDDEN: 403,
  },
};
